// extracted by mini-css-extract-plugin
export default {"vocabList":"Scripted_vocabList__f3UCj","vocab":"Scripted_vocab__86+82","selectedVocab":"Scripted_selectedVocab__Efc5s","recorder":"Scripted_recorder__8j5hD"};